export const useCredits = /* GraphQL */ `
  mutation useCredits($operation: CreditOperation!, $amount: Int!, $referenceId: ID) {
    useCredits(operation: $operation, amount: $amount, referenceId: $referenceId) {
      success
      error
      newBalance
      transactionId
    }
  }
`;

export const createStripeCheckoutSession = /* GraphQL */ `
  mutation createStripeCheckoutSession($input: CreateStripeCheckoutInput!) {
    createStripeCheckoutSession(input: $input) {
      sessionId
      sessionUrl
      error
    }
  }
`;

export const createStripePortalSession = /* GraphQL */ `
  mutation createStripePortalSession($input: CreateStripePortalInput!) {
    createStripePortalSession(input: $input) {
      sessionUrl
      error
    }
  }
`;

export const cancelSubscription = /* GraphQL */ `
  mutation cancelSubscription {
    cancelSubscription {
      success
      error
      cancellationDate
    }
  }
`;

export const grantbonusPercentage = /* GraphQL */ `
  mutation grantbonusPercentage($userId: ID!, $amount: Int!, $reason: String!) {
    grantbonusPercentage(userId: $userId, amount: $amount, reason: $reason) {
      success
      error
      newBalance
      transactionId
    }
  }
`;
